import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import * as React from "react";

export default function StaffVouchersChangeVoucherNumber(props) {

    const [chipOri, setChipOri] = useState('');
    const [chip, setChip] = useState('');

    useEffect(() => {
        if(props.chip) setChipOri(props.chip);
        if(props.chip) setChip(props.chip);
    }, [props.chip]);


    function handleClose() {

        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/voucher/update/') + props.voucherId,
            {a_microchip_number: chip}
        ).then((r) => {
            props.setChip(chip);
            props.setOpen(false);
        })

    }

    return (
        <Dialog open={props.open} onClose={() => props.setOpen(false)}>
            <DialogTitle>Microchip</DialogTitle>
            <DialogContent style={{minWidth: 450}}>

                <TextField
                    autoFocus
                    margin="dense"
                    id="mc"
                    label={"Change the microchip number of this animal here."}
                    type="text"
                    fullWidth
                    variant="standard"
                    value={chip}
                    error={chip?.length !== 15}
                    onChange={(e) => setChip(e.target.value.replace(/\D/g, ''))}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)}>Cancel</Button>
                <Button onClick={handleClose} disabled={
                    (chip === '' || chip === chipOri || chip.length !== 15)
                }>Change</Button>
            </DialogActions>
        </Dialog>
    )
}
